import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApplicationPackage, ApplicationPackageService, WorkflowAction } from 'src/app/services/application-package.service';
import { PermitAnnualOperatingPlanApi, PermitAopService } from 'src/app/services/permit-aop.service';
import { PermitApplicationService } from 'src/app/services/permit-application.service';
import { PermitProjectFacilityAopService, ProjectFacilityAnnualOperatingPlanApi } from 'src/app/services/permit-project-facility-aop.service';
import { PermitSubmitStatusService } from 'src/app/services/permit-submit-status.service';
import { PermitVarianceService } from 'src/app/services/permit-variance.service';
import { PodsService } from 'src/app/services/pods.service';
import { PrintService } from 'src/app/services/print.service';
import { StatusRow } from 'src/app/modules/shared/components/status-container/status-container.component';


@Component({
  selector: 'app-new-permit',
  templateUrl: './new-permit.component.html',
  styleUrls: ['./new-permit.component.scss']
})
export class NewPermitComponent implements OnInit {

  projectSubmitted: boolean = false;
  varianceShow: boolean = true;
  varianceSubmitted: boolean = false;
  appShow: boolean = true;
  appSubmitted: boolean = false;
  aopShow: boolean = true;
  aopSubmitted: boolean = false;
  projectBeingReviewed: boolean = false;
  projectAccepted: boolean = false;
  eventsSubmitted: boolean = false;
  waterRightsId: string;
  applicationNumber: string;
  modificationId: string;
  varianceNumberFormatted: string;
  modalTitle: string;
  modalMessage: string;
  modalActionName: string;
  modalAction: string;
  modalWorkflowType: string;
  permitStartDate: Date;
  permitEndDate: Date;

  url: string;
  urlPackageId: number;
  urlPermitAopId: number;
  projectFacilityAOPs: ProjectFacilityAnnualOperatingPlanApi[];
  varianceActions: WorkflowAction[] = [];
  aopActions: WorkflowAction[] = [];
  activeIds: string[] = [];
  printMode: boolean = true;
  permitTypeName: string = "";

  unsubscribe: Subject<any> = new Subject;

  applicationPackage: ApplicationPackage;
  applicationPackageStatus: string;
  applicationPackageStatusRows: StatusRow[];
  aop: PermitAnnualOperatingPlanApi;
  permitAnnualOperatingPlanStatus: string;
  permitAnnualOperatingPlanStatusRows: StatusRow[];
  projectFacilityOperatingPlanStatus: string;

  rejectVarianceAction: any;
  rejectVarianceComment: string;
  rejectFacilityComment: string;
  //dssInstructions: DSSInstructionsApi;

  constructor(
    private route: ActivatedRoute,
    private podsService: PodsService,
    private applicationPackageService: ApplicationPackageService,
    private varianceService: PermitVarianceService,
    private permitAppService: PermitApplicationService,
    private aopService: PermitAopService,
    private pfAopService: PermitProjectFacilityAopService,
    private location: Location,
    public printService: PrintService,
    private modalService: NgbModal,
    private permitSubmitStatusService: PermitSubmitStatusService
  ) { }

  ngOnInit() {

    this.applicationPackageService.getDSSInstruction();
    /*
    this.applicationPackageService.dssInstructions.pipe(takeUntil(this.unsubscribe))
    .subscribe(ins => {
      this.dssInstructions = ins;
    });
    */

    // If at least one Project Facility AOP exists, enable Package Submittal
    this.pfAopService.currentProjectFacilityAops.subscribe(projectFacilityAOPs => {
      this.projectFacilityAOPs = projectFacilityAOPs;
    });

    this.permitSubmitStatusService.currentApplicationPackageStatus.subscribe(currentApplicationPackageStatus => {
      this.applicationPackageStatus = currentApplicationPackageStatus ? '' : 'disabled';
    });

    this.permitSubmitStatusService.currentPermitAnnualOperatingPlanStatus.subscribe(currentPermitAnnualOperatingPlanStatus => {
      this.permitAnnualOperatingPlanStatus = currentPermitAnnualOperatingPlanStatus ? '' : 'disabled';
      console.log("Permit: " + currentPermitAnnualOperatingPlanStatus.valueOf());
    });

    this.permitSubmitStatusService.currentPermitAnnualOperatingPlanStatus.subscribe(currentProjectFacilityOperatingPlanStatus => {
      this.projectFacilityOperatingPlanStatus = currentProjectFacilityOperatingPlanStatus ? '' : 'disabled';
      console.log("Project: " + currentProjectFacilityOperatingPlanStatus.valueOf());
    });

    this.route.url.subscribe(url => {

      //check url
      this.url = url[0].path;

      if (this.url === "new-permit") {
        this.applicationPackageService.changePackage(null);
        this.varianceService.changeVariance(null);
        this.permitAppService.changeApplication(null);
        this.aopService.changeAop(null);
        this.pfAopService.changePfaops([]);
      }

      if (url.length > 1) {

        this.projectSubmitted = true;
        // Grab the Package Id so I can grab the rest of the info
        this.urlPackageId = parseInt(url[1].path);
        this.applicationPackageService.getPackage(this.urlPackageId);

        this.urlPermitAopId = parseInt(url[2].path);
        this.aopService.getAop(this.urlPermitAopId);

      } else {

        this.podsService.currentPod
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(pod => {
          this.urlPackageId = parseInt(pod);
        })

      }

      this.applicationPackageService.currentApplicationPackage
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(applicationPackage => {
        if (applicationPackage) {
          this.applicationPackage = applicationPackage;
          if (applicationPackage.permitStatusName === "Draft" && this.url === "permit-facilities") {
            this.changeUrl("permit-status");
          }
          this.urlPackageId = applicationPackage.applicationPackageId;
          this.varianceActions = applicationPackage.allowedWorkflowActions;
          this.permitTypeName = applicationPackage.permitTypeName;
          /* ADD A CHECK FOR PERMIT TYPE - IF PERMANENT Don't Show Application on application section */
          this.generateApplicationPackageStatusRows(applicationPackage);
          this.generateAOPStatusRows(applicationPackage, this.aop);
        }
      });

      this.aopService.currentAop
      .pipe(takeUntil(this.unsubscribe))
      .subscribe( aop => {
        if (aop) {
          this.aop = aop;
          this.aopActions = aop.allowedWorkflowActions;
          if (this.urlPermitAopId == null) {
            this.urlPermitAopId = aop.permitAnnualOperatingPlanId;
          }
          this.generateAOPStatusRows(this.applicationPackage, aop);
        }
      });

      this.permitAppService.currentApplication
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(app => {
          if (app) {
            if (this.waterRightsId == null) {
              this.waterRightsId = app.waterRightsId;
              this.applicationNumber = app.applicationNumber;

            }
          }
        });

    });

  }

  ngOnDestroy() {
    this.applicationPackageService.changePackage(null);
    this.aopService.changeAop(null);
    this.pfAopService.changePfaops([]);
    this.varianceService.changeVariance(null);
    this.permitAppService.changeApplication(null);
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ifAppIsWithdrawn() {
    return this.applicationPackage.permitStatusName === 'Withdrawn' ?
      " (Withdrawn)" : "";
  }

  ifPAOPIsWithdrawn() {
    return this.aop.permitAnnualOperatingPlanStatusName === 'Withdrawn' ?
      " (Withdrawn)" : "";
  }

  generateApplicationPackageStatusRows(applicationPackage: ApplicationPackage) {
    switch (applicationPackage.permitStatusId) {
      case 1: // Draft
        this.applicationPackageStatusRows = [
          { status: "started", topText: "In Progress", bottomText: "Status", actionUser: applicationPackage.submittedUserName, actionTimestamp: applicationPackage.submittedTimestamp },
          { status: "empty", topText: "Upcoming", bottomText: "DWEE Filing Review", actionUser: applicationPackage.acceptedUserName, actionTimestamp: applicationPackage.acceptedTimestamp },
          { status: "empty", topText: "Upcoming", bottomText: "Variance Petition Approval", actionUser: applicationPackage.approvedUserName, actionTimestamp: applicationPackage.approvedTimestamp }
        ];
        break;
      case 2: // Submitted
        this.applicationPackageStatusRows = [
          { status: "complete", topText: "Submitted", bottomText: "Status", actionUser: applicationPackage.submittedUserName, actionTimestamp: applicationPackage.submittedTimestamp },
          { status: "started", topText: "In Progress", bottomText: "DWEE Filing Review", actionUser: applicationPackage.acceptedUserName, actionTimestamp: applicationPackage.acceptedTimestamp },
          { status: "empty", topText: "Upcoming", bottomText: "Variance Petition Approval", actionUser: applicationPackage.approvedUserName, actionTimestamp: applicationPackage.approvedTimestamp }
        ];
        break;
      case 3: // Accepted
        this.applicationPackageStatusRows = [
          { status: "complete", topText: "Submitted", bottomText: "Status", actionUser: applicationPackage.submittedUserName, actionTimestamp: applicationPackage.submittedTimestamp },
          { status: "complete", topText: "Filing Accepted", bottomText: "DWEE Filing Review", actionUser: applicationPackage.acceptedUserName, actionTimestamp: applicationPackage.acceptedTimestamp },
          { status: "started", topText: "In Progress", bottomText: "Variance Petition Approval", actionUser: applicationPackage.approvedUserName, actionTimestamp: applicationPackage.approvedTimestamp }
        ];
        break;
      case 4: // Acceptance Failed
        this.applicationPackageStatusRows = [
          { status: "complete", topText: "In Progress", bottomText: "Status", actionUser: applicationPackage.submittedUserName, actionTimestamp: applicationPackage.submittedTimestamp },
          { status: "failed", topText: "Filing Not Accepted", bottomText: "DWEE Filing Review", actionUser: applicationPackage.acceptedUserName, actionTimestamp: applicationPackage.acceptedTimestamp },
          { status: "empty", topText: "Upcoming", bottomText: "Variance Petition Approval", actionUser: applicationPackage.approvedUserName, actionTimestamp: applicationPackage.approvedTimestamp }
        ];
        break;
      case 5: // Approved
        this.applicationPackageStatusRows = [
          { status: "complete", topText: "Submitted", bottomText: "Status", actionUser: applicationPackage.submittedUserName, actionTimestamp: applicationPackage.submittedTimestamp },
          { status: "complete", topText: "Filing Accepted", bottomText: "DWEE Filing Review", actionUser: applicationPackage.acceptedUserName, actionTimestamp: applicationPackage.acceptedTimestamp },
          { status: "complete", topText: "Variance Petition Approved", bottomText: "Variance Petition Approval", actionUser: applicationPackage.approvedUserName, actionTimestamp: applicationPackage.approvedTimestamp }
        ];
        break;
      case 5: // Denied
        this.applicationPackageStatusRows = [
          { status: "failed", topText: "Submitted", bottomText: "Status", actionUser: applicationPackage.submittedUserName, actionTimestamp: applicationPackage.submittedTimestamp },
          { status: "failed", topText: "Filing Rejected", bottomText: "DWEE Filing Review", actionUser: applicationPackage.acceptedUserName, actionTimestamp: applicationPackage.acceptedTimestamp },
          { status: "failed", topText: "Variance Petition Rejected", bottomText: "Variance Petition Approval", actionUser: applicationPackage.approvedUserName, actionTimestamp: applicationPackage.approvedTimestamp }
        ];
        break;
    }
  }

  generateAOPStatusRows(applicationPackage: ApplicationPackage, aop: PermitAnnualOperatingPlanApi) {
    if (applicationPackage && aop && aop.permitAnnualOperatingPlanStatusId) {
      if (applicationPackage.permitTypeName === 'Permanent') {
        this.generatePermanentAOPStatusRows(aop);
      } else if (applicationPackage.permitTypeName === 'Temporary') {
        this.generateTemporaryAOPStatusRows(aop);
      }
    }
  }
  generatePermanentAOPStatusRows(aop: PermitAnnualOperatingPlanApi) {
    switch (aop.permitAnnualOperatingPlanStatusId) {
      case 1: // Waiting For Variance Submittal
        this.permitAnnualOperatingPlanStatusRows = [
          { status: "empty", topText: "Pending Variance Submittal", bottomText: "Status", actionUser: aop.submittedUserName, actionTimestamp: aop.submittedTimestamp },
          { status: "empty", topText: "Upcoming", bottomText: "Application Acceptance", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
        ];
        break;
      case 2: // Draft
        this.permitAnnualOperatingPlanStatusRows = [
          { status: "started", topText: "In Progress", bottomText: "Status", actionUser: aop.submittedUserName, actionTimestamp: aop.submittedTimestamp },
          { status: "empty", topText: "Upcoming", bottomText: "Application Acceptance", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
        ];
        break;
      case 3: // Submitted
      case 4: // Accepted
        this.permitAnnualOperatingPlanStatusRows = [
          { status: "complete", topText: "Submitted", bottomText: "Status", actionUser: aop.submittedUserName, actionTimestamp: aop.submittedTimestamp },
          { status: "started", topText: "In Progress", bottomText: "Application Acceptance", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
        ];
        break;
      case 5: // Acceptance Failed
        this.permitAnnualOperatingPlanStatusRows = [
          { status: "started", topText: "In Progress", bottomText: "Status", actionUser: aop.submittedUserName, actionTimestamp: aop.submittedTimestamp },
          { status: "failed", topText: "Application Not Accepted", bottomText: "Application Acceptance", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
        ];
        break;
      case 6: // Approved
        this.permitAnnualOperatingPlanStatusRows = [
          { status: "complete", topText: "Submitted", bottomText: "Status", actionUser: aop.submittedUserName, actionTimestamp: aop.submittedTimestamp },
          { status: "complete", topText: "Application Accepted", bottomText: "Application Acceptance", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
        ];
        break;
      case 7: // Denied
        this.permitAnnualOperatingPlanStatusRows = [
          { status: "failed", topText: "Submitted", bottomText: "Status", actionUser: aop.submittedUserName, actionTimestamp: aop.submittedTimestamp },
          { status: "failed", topText: "Application Rejected", bottomText: "Application Acceptance", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
        ];
        break;
    }
  }
  generateTemporaryAOPStatusRows(aop: PermitAnnualOperatingPlanApi) {
    switch (aop.permitAnnualOperatingPlanStatusId) {
      case 1: // Waiting For Variance Submittal
        this.permitAnnualOperatingPlanStatusRows = [
          { status: "empty", topText: "Pending Variance Submittal", bottomText: "Status", actionUser: aop.submittedUserName, actionTimestamp: aop.submittedTimestamp },
          { status: "empty", topText: "Upcoming", bottomText: "DWEE Filing Review", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
          { status: "empty", topText: "Upcoming", bottomText: "Application Approval", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
        ];
        break;
      case 2: // Draft
        this.permitAnnualOperatingPlanStatusRows = [
          { status: "started", topText: "In Progress", bottomText: "Status", actionUser: aop.submittedUserName, actionTimestamp: aop.submittedTimestamp },
          { status: "empty", topText: "Upcoming", bottomText: "DWEE Filing Review", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
          { status: "empty", topText: "Upcoming", bottomText: "Application Approval", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
        ];
        break;
      case 3: // Submitted
        this.permitAnnualOperatingPlanStatusRows = [
          { status: "complete", topText: "Submitted", bottomText: "Status", actionUser: aop.submittedUserName, actionTimestamp: aop.submittedTimestamp },
          { status: "started", topText: "In Progress", bottomText: "DWEE Filing Review", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
          { status: "empty", topText: "Upcoming", bottomText: "Application Approval", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
        ];
        break;
      case 4: // Accepted
        this.permitAnnualOperatingPlanStatusRows = [
          { status: "complete", topText: "Submitted", bottomText: "Status", actionUser: aop.submittedUserName, actionTimestamp: aop.submittedTimestamp },
          { status: "complete", topText: "Filing Accepted", bottomText: "DWEE Filing Review", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
          { status: "started", topText: "In Progress", bottomText: "Application Approval", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
        ];
        break;
      case 5: // Acceptance Failed
        this.permitAnnualOperatingPlanStatusRows = [
          { status: "started", topText: "In Progress", bottomText: "Status", actionUser: aop.submittedUserName, actionTimestamp: aop.submittedTimestamp },
          { status: "failed", topText: "Filing Not Accepted", bottomText: "DWEE Filing Review", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
          { status: "empty", topText: "Application Not Accepted", bottomText: "Application Approval", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
        ];
        break;
      case 6: // Approved
        this.permitAnnualOperatingPlanStatusRows = [
          { status: "complete", topText: "Submitted", bottomText: "Status", actionUser: aop.submittedUserName, actionTimestamp: aop.submittedTimestamp },
          { status: "complete", topText: "Filing Accepted", bottomText: "DWEE Filing Review", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
          { status: "complete", topText: "Application Approved", bottomText: "Application Approval", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
        ];
        break;
      case 7: // Denied
        this.permitAnnualOperatingPlanStatusRows = [
          { status: "failed", topText: "Submitted", bottomText: "Status", actionUser: aop.submittedUserName, actionTimestamp: aop.submittedTimestamp },
          { status: "failed", topText: "Filing Rejected", bottomText: "DWEE Filing Review", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
          { status: "empty", topText: "Application Rejected", bottomText: "Application Approval", actionUser: aop.approvedUserName, actionTimestamp: aop.approvedTimestamp },
        ];
        break;
    }
  }

  projectFormSubmitted = () => this.projectSubmitted = true;

  hideForms = () => this.activeIds = [];

  varianceFormSubmitted = () => this.varianceSubmitted = true;

  appFormSubmitted = () => this.appSubmitted = true;

  aopFormSubmitted = () => this.aopSubmitted = true;

  eventsSubmit(form: any, event: Event) {
    event.preventDefault();
    this.eventsSubmitted = true;
  }

  packageDownload = () => console.log("Downloading PDF...");

  packageSubmit = (action: string) => this.applicationPackageService.submitPackage(action);

  changeUrl = (url: string) => {
    this.url = url;
    this.location.replaceState(`${url}/${this.urlPackageId}/${this.urlPermitAopId}`);
  }

  appPackageWorkflow (action: string, comment: string = '') {
    this.applicationPackageService.submitPackage(action, comment);
    this.modalService.dismissAll();
  }

  aopWorkflow (action: string, comment: string='') {
    this.aopService.workflowAOP(action, comment);
    this.modalService.dismissAll();
  }

  processWorkflow(workflowType: string, action: string, comment: string = '') {
    if (workflowType == 'appPackageWorkflow') {
      this.appPackageWorkflow(action, comment);
    } else if (workflowType == 'aopWorkflow') {
      this.aopWorkflow(action, comment)
    } else {
      this.modalService.dismissAll();
    }
  }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
  }

/* Open reusable modal for alerting and confirmation */
  genericModalShow(modal, title, message, actionName, action, workflowType) {
    const activeModal = this.modalService.open(modal, { size: 'xl' });
    this.modalTitle = title;
    this.modalMessage = message;
    this.modalActionName = actionName;
    this.modalAction = action;
    this.modalWorkflowType = workflowType;
  }

  submitWaterRightsId() {
    this.aopService.submitWaterRightsId(this.waterRightsId, this.applicationNumber, this.permitTypeName);
    this.modalService.dismissAll();
  }

  submitStartEndDates() {
    this.aopService.submitStartEndDate(this.permitStartDate, this.permitEndDate);
    this.modalService.dismissAll();
  }

  submitModificationId() {
    this.applicationPackageService.submitModificationId(this.modificationId);
    this.modalService.dismissAll();
  }

  showSection(name: string) {
    if (!!this.activeIds) {
      if (this.activeIds[0] === name) {
        this.hideForms();
      }
      else {
        this.activeIds = [name];
      }
    }
  }

  showDraftApplication($event) {
    this.showSection('draft-application');
  }

  showVariance($event) {
    this.showSection('variance-petition');
  }

  showApplication($event) {
    this.showSection('application');
  }

  showOperation($event) {
    this.showSection('general-operations');
  }

  showFacility($event) {
    this.hideForms();
    this.activeIds = ['recharge-facilities'];
  }
}
